module.exports = __webpack_public_path__ + "static/media/img-2.73980c6e.jpg";